import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DomainRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Check if redirection has already occurred in this session
        const policyPages = ["terms", "privacy", "refund", "disclaimer", "deliverypolicy", "joinwhatsapp", "getpreferencelist", "cp-pdf-dashboard", "testseries-pcm"];
        const pathnamepolicy = window.location.pathname;
        const pathPolicyPart1 = pathnamepolicy.split('/')[1];
        const pathPolicyPart2 = pathnamepolicy.split('/')[2];

        if (policyPages?.indexOf(pathPolicyPart1) != -1) {
            navigate(`/${pathPolicyPart1}`, { replace: true });
            return;
        }
        // Allow ACAP route with ApplicationId
        if (pathPolicyPart1 === "acap" && pathPolicyPart2) {
            return;
        }
        const alreadyRedirected = sessionStorage.getItem('domainRedirected');

        if (!alreadyRedirected) {
            const domain = window.location.hostname;
            const pathname = window.location.pathname;
            const pathPart1 = pathname.split('/')[1];
            const pathPart2 = pathname.split('/')[2];
            const pathPart3 = pathname.split('/')[3];
            const pathPart4 = pathname.split('/')[4];


            console.log('domain - ', domain)
            console.log('window - ', window);
            console.log('pathPart1 - ', pathPart1, 'pathPart2 - ', pathPart2, 'pathPart3 - ', pathPart3, 'pathPart4 - ', pathPart4)
            // Set flag so it doesn't happen again this session
            sessionStorage.setItem('domainRedirected', 'true');

            if (domain.includes('127.0.0.1')) {

                // allow referral urls
                if (
                    pathPart1 === "medineer" &&
                    pathPart2
                ) {
                    return;
                }

                if (pathPart1 === 'forgotPass') {
                    navigate(`/forgotPass/${pathPart2}`, { replace: true });
                } else {
                    navigate('/medineer', { replace: true });
                }
            }
            else if (domain.includes('localhost')) {
                if (pathPart1 && (pathPart1 === 'signin' || pathPart1 === 'signIn')) {
                    // Redirect to sign-in with id from URL
                    navigate(`/signin/${pathPart2}`, { replace: true });
                } else if (pathPart1 && pathPart1 === 'forgotPass') {
                    navigate(`/forgotPass/${pathPart2}`, { replace: true });
                } else {
                    // Default redirect to letsStart
                    navigate('/letsStart', { replace: true });
                }
            }
            else if (domain.includes('live-assess-ui-demo.azurewebsites.net') && pathPart1 && pathPart1 !== 'medineer') {

                if (pathPart1 && (pathPart1 === 'signin' || pathPart1 === 'signIn')) {
                    navigate(`/signin/${pathPart2}`, { replace: true });
                } else if ((pathPart1 === 'forgotPass')) {
                    navigate(`/forgotPass/${pathPart2}`, { replace: true })
                } else if ((pathPart1 === 'letStart')) {
                    navigate('/letStart', { replace: true });
                } else {
                    navigate('/signin', { replace: true });
                }
            } else if (domain.includes('live-assess-ui-demo.azurewebsites.net') && pathPart1 && pathPart1 === 'medineer') {
                if ((pathPart1 === 'forgotPass')) {
                    navigate(`forgotPass/${pathPart2}`, { replace: true })
                } else {
                    navigate(`/medineer`, { replace: true });
                }
            } else if (domain.includes('live-assess-ui.azurewebsites.net')) {
                navigate('/medineer', { replace: true });
            } else if (domain.includes('medineer.ai')) {

                // allow referral urls
                if (
                    pathPart1 === "medineer" &&
                    pathPart2
                ) {
                    return;
                }

                if (pathPart1 === "forgotPass") {
                    navigate(`/forgotPass/${pathPart2}`, { replace: true });
                }
                else if (!pathPart1) {
                    navigate('/medineer', { replace: true });
                }
            } else if (domain.includes('learner.learningfitbit.com')) {
                if (pathPart1 && (pathPart1 === 'signin' || pathPart1 === 'signIn')) {
                    // Redirect to sign-in with id from URL
                    navigate(`/signin/${pathPart2}`, { replace: true });
                } else if (pathPart1 && pathPart1 === 'forgotPass') {
                    navigate(`/forgotPass/${pathPart2}`, { replace: true });
                } else {
                    // Default redirect to letsStart
                    navigate('/letsStart', { replace: true });
                }
            } else {
                navigate(`/signin`);
                console.log('default route');
            }
        }
    }, [navigate]);

    return null;
};

export default DomainRedirect;